module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAD0kAz0kAz0kAz0kAz0kAz0kAz3rEn6yIb////848L0kAz++PD71aT6zpX+8eH4umf3s1j83LP96tH1nir2pTr5wXb4SO8kAAAAB3RSTlMAYL8AIM/vi50ITwAAAOxJREFUeF7t2EmKw0AMhtEqD5FUo4ek73/UVhYN9iYSWA0O6DvA2xhB+Q/v4pAvNMSRC+M4zfli8/SGpke+3GNiaM4GzWOI2aQYBhtoCNmoW0EOrYXKagFtRJQsoPR/kEOA6VRhqKRzCDJUSVWVoIWUrQJUtVAToMRAWeDQzsAOx5bCUFJAKH21ZgXh/SCHEh7rDHU8lZSQ3NdCFT7fGlQZ8hNxqErQpoRob5+Otu3EbQKEpAwF6Kl0ylOA8to1TgfFa+QF0tHCy19sfznk0A9DaAFlQLjXH6RDZiOL2exjNUSZTWOWYx1nMR/+Ardh1h1GAw+AAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f238.png
// module id = 632
// module chunks = 0